import React, {FC, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import {fetchData, getEncryptedRoute, toasterrormsg, toastsuccessmsg, useMenuIdPermissions} from '../../../reusable'
import {ToastContainer} from 'react-toastify'
import { Tr } from '../../../_metronic/i18n/Tr'

interface AddHotelHeaderProps {
  bookingId: string // Assuming bookingId is of type string, adjust as needed
  bookingdetailId: string // Assuming bookingId is of type string, adjust as needed
}

const CustomerDetail: React.FC<AddHotelHeaderProps> = ({bookingId, bookingdetailId}) => {
  let t = Tr()
      const { menuId} = useMenuIdPermissions()


  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)

  const [fullName, setFullName] = useState('')
  const [mobileNumber, setMobileNumber] = useState('')
  const [email, setEmail] = useState('')
  const [detailBookingId, setDetailBookingId] = useState('')

  const validate = () => {
    var isValid = true
    const regex = /^[0-9]*$/
    const emailValidate = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    var errorTmp = [...error]
    if (fullName == '') {
      errorTmp[0].fullName = t('Full Name Is Required')
      isValid = false
    } else if (regex.test(fullName)) {
      errorTmp[0].fullName = t('Only Character are Allowed')
      isValid = false
    } else if (mobileNumber == '') {
      errorTmp[0].mobileNumber = t('Mobile Number Is Required')
      isValid = false
    } else if (!regex.test(mobileNumber)) {
      errorTmp[0].mobileNumber = t('Mobile Number Is Not Valid')
      isValid = false
    } else if (email == '') {
      errorTmp[0].email = t('Email Is Required')
      isValid = false
    } else if (!emailValidate.test(email)) {
      errorTmp[0].email = t('Email Is Not valid')
      isValid = false
    }

    setError(errorTmp)
    return isValid
  }

  const editBookingDetails = async () => {
    if (validate()) {
      setDisable(true)
      setLoading(true)
      var tmp2 = sessionStorage.getItem('admin')
      // Step 2: Check if the item is not null
      if (tmp2) {
        // Step 3: Parse the JSON string
        var adminData = JSON.parse(tmp2)
        // Step 4: Access the adminId
        var adminId = adminData.adminId
      }
      var param: any = {
        updateStatus: '0',
        bookingId: String(bookingId),
        bookingdetailId: bookingdetailId,
        adminId: adminId,
        userName: fullName,
        email: email,
        userMobileNumber: mobileNumber,
      }

      var res = await fetchData('admin/edittourpackagebooking', param)
      if (res.status == '200') {
        setDisable(false)
        setLoading(false)
        BookingListApiCall()
        toastsuccessmsg('Updated Successfully')
      } else {
        setDisable(false)
        setLoading(false)
        toasterrormsg(res.message)
      }
    }
  }

  const BookingListApiCall = async () => {
    var param: any = {
      bookingId: bookingId,
      categoryId: '5',
    }

    var res = await fetchData('admin/bookingdetail', param)

    if (res.status == '200') {
      var data = res.data[0]

      setDetailBookingId(data.bookingId)

      setFullName(data.userName ? data.userName : '')
      setMobileNumber(data.mobileNumber ? data.mobileNumber : '')
      setEmail(data.email ? data.email : '')
    } else {
    }
  }

  useEffect(() => {
    BookingListApiCall()
  }, [])

  const [error, setError] = useState([
    {
      email,
      mobileNumber,
      fullName,
    },
  ])

  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }

  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>
      {t("Edit Booking Details")}
      </PageTitle>
      <div className='d-flex flex-column flex-column-fluid'>
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          <div className='form d-flex flex-column flex-lg-row'>
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              <div className='tab-content'>
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    <div className='card card-flush py-4'>
                      <div className='card-header d-flex'>
                        <div className='card-title'>
                          <h2>{t("Customer Info")}</h2>
                        </div>

                      </div>

                      <div className='card-body pt-0'>
                        
                        <div className='row'>
                          <div className='col-lg-4 my-3'>
                            
                            <label className='required fs-4 form-label'>{t("Customer Name")}</label>
                            
                            <input
                              type='text'
                              name='customerName'
                              className='form-control mb-2'
                              placeholder={t('Customer Name')}
                              value={fullName}
                              onChange={(e) => {
                                setFullName(e.target.value)
                                removeError('fullName')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].fullName}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            <label className='required fs-4 form-label'>{t("Mobile Number")}</label>
                            
                            <input
                              type='text'
                              name='mobileNumber'
                              className='form-control mb-2'
                              placeholder={t('Mobile Number')}
                              value={mobileNumber}
                              onChange={(e) => {
                                setMobileNumber(e.target.value)
                                removeError('mobileNumber')
                              }}
                            />

                            <div className='text-danger fw-bold'>{error[0].mobileNumber}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            
                            <label className='required fs-4 form-label'>{t("Email")}</label>
                        
                            <input
                              type='text'
                              name='customerName'
                              className='form-control mb-2'
                              placeholder={t('Email')}
                              value={email}
                              onChange={(e) => {
                                setEmail(e.target.value)
                                removeError('email')
                              }}
                            />
                            <div className='text-danger fw-bold'>{error[0].email}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='d-flex justify-content-end'>
                <Link
                                    to={getEncryptedRoute('../viewtourbookingdetails/', {menuId:menuId})}

                  id='kt_ecommerce_add_product_cancel'
                  className='btn btn-light me-5'
                  state={{bookingId: detailBookingId}}
                >
                  {t("Cancel")}
                </Link>

                <button
                  onClick={() => {
                    editBookingDetails()
                  }}
                  type='button'
                  disabled={disable}
                  className='btn btn-primary'
                >
                  <span className='indicator-label'>{t("Save")}</span>
                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm mx-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {CustomerDetail}
